<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="100%" viewBox="0 0 400 265" enable-background="new 0 0 400 265" xml:space="preserve">
<path fill="#0C1727" opacity="1.000000" stroke="none" 
	d="
M0.999997,244.000000 
	C1.000000,170.645767 1.000000,97.291542 1.320946,23.358944 
	C6.496925,13.897619 12.725246,6.406980 22.305891,2.271897 
	C22.655182,2.121140 22.773851,1.436064 23.000000,1.000000 
	C141.354233,1.000000 259.708466,1.000000 378.641052,1.320944 
	C385.312714,5.812680 392.203857,8.998897 396.165314,15.766241 
	C397.627869,18.264729 399.379944,20.593716 401.000000,23.000000 
	C401.000000,96.354225 401.000000,169.708450 400.679077,243.641037 
	C395.503510,253.102737 389.275757,260.593933 379.694305,264.728241 
	C379.345001,264.878967 379.226196,265.563965 379.000000,266.000000 
	C260.645782,266.000000 142.291550,266.000000 23.358927,265.679077 
	C16.688068,261.187225 9.794909,258.004700 5.839999,251.230484 
	C4.380477,248.730530 2.622079,246.405060 0.999997,244.000000 
M362.564056,159.896774 
	C357.188354,136.388504 351.717926,112.901093 346.529602,89.351532 
	C345.659607,85.402664 344.308411,83.628159 340.018433,83.971481 
	C335.056458,84.368576 330.033844,84.199379 325.045654,84.033150 
	C317.274628,83.774185 312.283142,87.193268 309.164124,94.366425 
	C297.027832,122.278084 284.655792,150.087204 272.399109,177.946655 
	C271.784271,179.344177 271.428650,180.855759 270.748138,182.939529 
	C276.122253,182.939529 280.662994,182.456223 285.062653,183.038635 
	C294.668396,184.310242 301.560730,182.137589 303.094543,171.252472 
	C303.494934,168.411179 305.589447,167.836975 308.254425,167.893768 
	C315.076080,168.039169 321.902924,167.939987 328.727692,167.939651 
	C338.822327,167.939178 338.762695,167.955048 341.258881,177.567917 
	C341.675171,179.171021 342.808533,181.830719 343.705994,181.870911 
	C351.394958,182.215134 359.105865,182.068359 367.485779,182.068359 
	C365.770538,174.284164 364.274384,167.494171 362.564056,159.896774 
M201.274170,181.296524 
	C212.163147,184.441132 223.304810,184.897110 234.464951,183.790649 
	C244.023575,182.842941 252.975540,179.920364 260.795990,173.952377 
	C272.946350,164.680145 278.960449,142.017365 260.295593,129.702866 
	C256.419312,127.145409 252.228745,125.063751 248.179092,122.769798 
	C244.707504,120.803291 241.004333,119.155579 237.806503,116.816147 
	C232.519760,112.948502 232.891998,107.840149 238.927643,105.251396 
	C242.769470,103.603592 247.321365,102.575523 251.446350,102.857422 
	C258.256805,103.322845 264.979523,105.072182 271.958862,106.319679 
	C272.814728,101.853500 273.615936,96.758568 274.805084,91.755836 
	C275.759033,87.742493 274.185669,85.998848 270.423645,85.082954 
	C257.717987,81.989655 244.905899,81.344437 232.423523,85.262711 
	C226.223343,87.208977 219.969315,90.354218 214.956207,94.447113 
	C201.479431,105.450150 202.114288,123.386864 216.007385,133.814590 
	C220.623474,137.279282 226.013565,139.715027 231.060196,142.602997 
	C233.945663,144.254242 237.063232,145.586304 239.704468,147.559738 
	C244.966446,151.491333 244.405609,157.860184 238.532700,160.889771 
	C236.228027,162.078659 233.532639,162.842926 230.946686,163.093414 
	C222.043869,163.955750 213.322891,163.066589 205.010895,159.444504 
	C203.083786,158.604736 201.088959,157.920349 198.545380,156.941238 
	C197.547485,162.733078 197.045364,168.041733 195.642654,173.100693 
	C194.298813,177.947388 195.542648,180.440796 201.274170,181.296524 
M125.135460,90.621544 
	C117.481071,110.197411 109.826675,129.773285 101.750999,150.426575 
	C95.179031,127.739685 79.926468,113.814835 62.283924,100.626564 
	C62.283924,102.496902 62.097015,103.340698 62.310974,104.066292 
	C69.652481,128.963501 77.063919,153.840164 84.360878,178.750366 
	C85.169662,181.511383 86.670128,182.363159 89.398949,182.305649 
	C95.891624,182.168839 102.402946,182.009415 108.879868,182.358139 
	C113.056465,182.583023 115.024078,180.999725 116.629799,177.219330 
	C129.055817,147.964340 141.704254,118.803856 154.266235,89.606544 
	C154.962509,87.988228 155.502762,86.302780 156.454788,83.733131 
	C148.502899,83.733131 141.372589,84.077156 134.294525,83.617149 
	C129.229691,83.287987 126.409203,85.004204 125.135460,90.621544 
M155.864914,153.278870 
	C154.240891,162.702698 152.616867,172.126511 150.869308,182.267212 
	C158.208817,182.267212 164.706482,181.848969 171.122070,182.394989 
	C176.594009,182.860687 178.139954,180.584320 178.946060,175.629974 
	C182.715988,152.460190 186.856384,129.350830 190.828857,106.213768 
	C192.059021,99.048889 193.177170,91.864777 194.501923,83.736351 
	C186.577560,83.736351 179.469177,83.904266 172.374405,83.666512 
	C168.750259,83.545067 167.503311,84.996117 166.935837,88.417343 
	C163.394135,109.769989 159.658035,131.090408 155.864914,153.278870 
M77.121460,83.066093 
	C62.997749,83.066093 48.874043,83.066093 34.750332,83.066093 
	C34.590233,83.683334 34.430130,84.300575 34.270031,84.917816 
	C60.794605,91.796806 82.659851,104.906631 95.844254,129.885498 
	C96.010353,128.362625 96.025505,126.928383 95.738503,125.557396 
	C93.490707,114.820023 91.197472,104.092087 88.892731,93.366722 
	C87.342621,86.153130 85.446327,84.386833 77.121460,83.066093 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M22.531218,1.000000 
	C22.773851,1.436064 22.655182,2.121140 22.305891,2.271897 
	C12.725246,6.406980 6.496925,13.897619 1.320946,22.890285 
	C1.000000,15.740432 1.000000,8.480865 1.000000,1.000000 
	C8.019269,1.000000 15.040852,1.000000 22.531218,1.000000 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M379.468781,266.000000 
	C379.226196,265.563965 379.345001,264.878967 379.694305,264.728241 
	C389.275757,260.593933 395.503510,253.102737 400.679077,244.109695 
	C401.000000,251.259567 401.000000,258.519135 401.000000,266.000000 
	C393.980743,266.000000 386.959137,266.000000 379.468781,266.000000 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M401.000000,22.531219 
	C399.379944,20.593716 397.627869,18.264729 396.165314,15.766241 
	C392.203857,8.998897 385.312714,5.812680 379.109680,1.320944 
	C386.259583,1.000000 393.519135,1.000000 401.000000,1.000000 
	C401.000000,8.019269 401.000000,15.040852 401.000000,22.531219 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M0.999997,244.468781 
	C2.622079,246.405060 4.380477,248.730530 5.839999,251.230484 
	C9.794909,258.004700 16.688068,261.187225 22.890270,265.679077 
	C15.740432,266.000000 8.480864,266.000000 1.000000,266.000000 
	C1.000000,258.980743 1.000000,251.959152 0.999997,244.468781 
z"/>
<path fill="#3361AA" opacity="1.000000" stroke="none" 
	d="
M362.671143,160.300476 
	C364.274384,167.494171 365.770538,174.284164 367.485779,182.068359 
	C359.105865,182.068359 351.394958,182.215134 343.705994,181.870911 
	C342.808533,181.830719 341.675171,179.171021 341.258881,177.567917 
	C338.762695,167.955048 338.822327,167.939178 328.727692,167.939651 
	C321.902924,167.939987 315.076080,168.039169 308.254425,167.893768 
	C305.589447,167.836975 303.494934,168.411179 303.094543,171.252472 
	C301.560730,182.137589 294.668396,184.310242 285.062653,183.038635 
	C280.662994,182.456223 276.122253,182.939529 270.748138,182.939529 
	C271.428650,180.855759 271.784271,179.344177 272.399109,177.946655 
	C284.655792,150.087204 297.027832,122.278084 309.164124,94.366425 
	C312.283142,87.193268 317.274628,83.774185 325.045654,84.033150 
	C330.033844,84.199379 335.056458,84.368576 340.018433,83.971481 
	C344.308411,83.628159 345.659607,85.402664 346.529602,89.351532 
	C351.717926,112.901093 357.188354,136.388504 362.671143,160.300476 
M333.930115,146.478546 
	C331.570007,135.311279 329.209900,124.144020 326.849762,112.976753 
	C326.406891,113.016876 325.964020,113.056999 325.521118,113.097122 
	C321.124786,124.501938 316.728455,135.906769 311.942566,148.322113 
	C319.868225,147.956604 326.768616,147.638382 333.930115,146.478546 
z"/>
<path fill="#3361A9" opacity="1.000000" stroke="none" 
	d="
M200.880890,181.194489 
	C195.542648,180.440796 194.298813,177.947388 195.642654,173.100693 
	C197.045364,168.041733 197.547485,162.733078 198.545380,156.941238 
	C201.088959,157.920349 203.083786,158.604736 205.010895,159.444504 
	C213.322891,163.066589 222.043869,163.955750 230.946686,163.093414 
	C233.532639,162.842926 236.228027,162.078659 238.532700,160.889771 
	C244.405609,157.860184 244.966446,151.491333 239.704468,147.559738 
	C237.063232,145.586304 233.945663,144.254242 231.060196,142.602997 
	C226.013565,139.715027 220.623474,137.279282 216.007385,133.814590 
	C202.114288,123.386864 201.479431,105.450150 214.956207,94.447113 
	C219.969315,90.354218 226.223343,87.208977 232.423523,85.262711 
	C244.905899,81.344437 257.717987,81.989655 270.423645,85.082954 
	C274.185669,85.998848 275.759033,87.742493 274.805084,91.755836 
	C273.615936,96.758568 272.814728,101.853500 271.958862,106.319679 
	C264.979523,105.072182 258.256805,103.322845 251.446350,102.857422 
	C247.321365,102.575523 242.769470,103.603592 238.927643,105.251396 
	C232.891998,107.840149 232.519760,112.948502 237.806503,116.816147 
	C241.004333,119.155579 244.707504,120.803291 248.179092,122.769798 
	C252.228745,125.063751 256.419312,127.145409 260.295593,129.702866 
	C278.960449,142.017365 272.946350,164.680145 260.795990,173.952377 
	C252.975540,179.920364 244.023575,182.842941 234.464951,183.790649 
	C223.304810,184.897110 212.163147,184.441132 200.880890,181.194489 
z"/>
<path fill="#3361AA" opacity="1.000000" stroke="none" 
	d="
M125.284866,90.259171 
	C126.409203,85.004204 129.229691,83.287987 134.294525,83.617149 
	C141.372589,84.077156 148.502899,83.733131 156.454788,83.733131 
	C155.502762,86.302780 154.962509,87.988228 154.266235,89.606544 
	C141.704254,118.803856 129.055817,147.964340 116.629799,177.219330 
	C115.024078,180.999725 113.056465,182.583023 108.879868,182.358139 
	C102.402946,182.009415 95.891624,182.168839 89.398949,182.305649 
	C86.670128,182.363159 85.169662,181.511383 84.360878,178.750366 
	C77.063919,153.840164 69.652481,128.963501 62.310974,104.066292 
	C62.097015,103.340698 62.283924,102.496902 62.283924,100.626564 
	C79.926468,113.814835 95.179031,127.739685 101.750999,150.426575 
	C109.826675,129.773285 117.481071,110.197411 125.284866,90.259171 
z"/>
<path fill="#3361AA" opacity="1.000000" stroke="none" 
	d="
M155.925629,152.850189 
	C159.658035,131.090408 163.394135,109.769989 166.935837,88.417343 
	C167.503311,84.996117 168.750259,83.545067 172.374405,83.666512 
	C179.469177,83.904266 186.577560,83.736351 194.501923,83.736351 
	C193.177170,91.864777 192.059021,99.048889 190.828857,106.213768 
	C186.856384,129.350830 182.715988,152.460190 178.946060,175.629974 
	C178.139954,180.584320 176.594009,182.860687 171.122070,182.394989 
	C164.706482,181.848969 158.208817,182.267212 150.869308,182.267212 
	C152.616867,172.126511 154.240891,162.702698 155.925629,152.850189 
z"/>
<path fill="#F4B10C" opacity="1.000000" stroke="none" 
	d="
M77.570564,83.088364 
	C85.446327,84.386833 87.342621,86.153130 88.892731,93.366722 
	C91.197472,104.092087 93.490707,114.820023 95.738503,125.557396 
	C96.025505,126.928383 96.010353,128.362625 95.844254,129.885498 
	C82.659851,104.906631 60.794605,91.796806 34.270031,84.917816 
	C34.430130,84.300575 34.590233,83.683334 34.750332,83.066093 
	C48.874043,83.066093 62.997749,83.066093 77.570564,83.088364 
z"/>
<path fill="#0D192A" opacity="1.000000" stroke="none" 
	d="
M333.799561,146.899353 
	C326.768616,147.638382 319.868225,147.956604 311.942566,148.322113 
	C316.728455,135.906769 321.124786,124.501938 325.521118,113.097122 
	C325.964020,113.056999 326.406891,113.016876 326.849762,112.976753 
	C329.209900,124.144020 331.570007,135.311279 333.799561,146.899353 
z"/>
</svg>